import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { FlexBox } from '../box';
import { IconLanguage } from '../icon';
import { Typography } from '../typography';
import { LanguagePickerMenu } from './menu';
import { StyledBarContainer } from './styled';
export const LanguagePickerBar = observer((props) => {
    const { disabled, title, disabledTooltipText, localeOptions } = props;
    const selectedOption = localeOptions.find((option) => option.value === props.locale) ??
        localeOptions[0];
    return (_jsx(StyledBarContainer, { children: _jsxs(FlexBox, { hAlign: "space-between", vAlign: "center", stretch: true, children: [_jsxs(FlexBox, { gap: 1, vAlign: "center", children: [_jsx(IconLanguage, { color: "components.language-picker.contrast.icon", fontSize: "small" }), _jsx(Typography, { color: "components.facility.contrast.text-top-navigation", children: title })] }), _jsx(LanguagePickerMenu, { options: localeOptions, selectedOption: selectedOption, disabled: disabled, disabledTooltipText: disabledTooltipText, onChange: props.onChange })] }) }));
});
